import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "panel"];

  apply(event) {
    const text = event.currentTarget.dataset.text || "";
    this.inputTarget.value = text;
    this.inputTarget.dispatchEvent(new Event("change"));
    this.inputTarget.scrollIntoView({ behavior: "smooth", block: "center" });
    this.inputTarget.focus();

    if (this.hasPanelTarget) this.panelTarget.hidden = true;
  }
}
